import * as React from 'react';

import { translate } from '~l10n/client';

import Select from '../../../../shared/components/elements/Select';

interface StudentTeamViewProps {
  controller: {
    teamChanged: (value: number) => void;
    startRacingClicked: () => void;
  };
  model: {
    isValidSelectedTeam: () => boolean;
    startAttempted: boolean;
    selectedTeam: number;
    teams: any[];
  };
  teamCount: number;
}

const StudentTeamView = ({
  controller,
  model,
  teamCount,
}: StudentTeamViewProps) => {
  const { teamChanged, startRacingClicked } = controller;
  const { isValidSelectedTeam, startAttempted, selectedTeam, teams } = model;
  const teamChildren = [];

  for (let i = 0; i < teamCount; i++) {
    const team = teams[i];
    const teamName = translate(team.name);
    teamChildren.push({
      title: teamName,
      value: i,
      selected: i === selectedTeam,
    });
  }

  return (
    <div className="take-quiz-container">
      <div id="select-team-container" className="form">
        <Select
          error={!isValidSelectedTeam() && startAttempted}
          label={translate('Select Your Team')}
          onSelect={(name, value) => teamChanged(value)}
        >
          {teamChildren}
        </Select>
        <div className="start-racing-container">
          <button
            id="submit-team-button"
            className="action-button action-button-200"
            onClick={startRacingClicked}
          >
            {translate('Start Racing')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentTeamView;
